module.exports = __webpack_public_path__ + "img/surfer.db714b5b.png";